import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import MappingForm from '../MappingForm';

import { Button } from '../../../../Styles';
import { MappingIcon } from '../../../../Styles';
import MappingFormV2 from '../MappingFormV2';

const AddMapping = ({ item = {}, refresh = null, ...props }) => {
	const { disableSingleInventoryMapping } = props;
	const { supplier_product_id: itemId, name: itemName } = item;
	const [openAddMapping, setOpenAddMapping] = useState(false);

	return (
		<>
			{!disableSingleInventoryMapping && (
				<Button
					secondary
					onClick={(e) => setOpenAddMapping(true)}
				>
					<MappingIcon />
					Add New Mapping
				</Button>
			)}

			{/* <MappingForm
				open={openAddMapping}
				item={{ itemId, itemName }}
				onSubmit={() => {
					if (refresh) {
						refresh();
					}
				}}
				onClose={() => {
					setOpenAddMapping(false);
				}}
			/> */}
			<MappingFormV2
				open={openAddMapping}
				item={{ itemId, itemName }}
				onSubmit={() => {
					if (refresh) {
						refresh();
					}
				}}
				onClose={() => {
					setOpenAddMapping(false);
				}}
			/>
		</>
	);
};

const mapStateToProps = (state) => {
	const supplierSellerPortalConfig = state.supplier.sellerPortalConfig || {};
	const userSellerPortalConfig = state.session.sellerPortalConfig || {};

	const disableSingleInventoryMapping = supplierSellerPortalConfig.disable_single_inventory_mapping || userSellerPortalConfig.disable_single_inventory_mapping || false;

	return {
		disableSingleInventoryMapping,
	};
};

const mapDispatch = {};

export default withRouter(connect(mapStateToProps, mapDispatch)(AddMapping));
